import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import AboutUs from "../AboutUs/AboutUs";
import Vision from "../Vision/Vision";
import Companies from "../Companies/Companies";
import BoardOfDirectors from "../BoardOfDirectors/BoardOfDirectors";
import Investments from "../Investments/Investments";
import Contact from "../Contact/Contact";
import AnnouncementsPage from "../Announcements/Announcements";
import AnnouncementDetails from "../Announcements/AnnouncementDetails/AnnouncementDetails";

const RedirectPage = () => {
  const [searchParams] = useSearchParams();
  const to = searchParams.get("to");
  const slug = searchParams.get("slug");

  const Component = useMemo(() => {
    switch (to) {
      case "about":
        return <AboutUs />;
      case "vision":
        return <Vision />;
      case "companies":
        return <Companies />;
      case "board":
        return <BoardOfDirectors />;
      case "investments":
        return <Investments />;
      case "contact":
        return <Contact />;
      case "announcements":
        return slug ? <AnnouncementDetails slug={slug} /> : <AnnouncementsPage />;
      default:
        return <AboutUs />;
    }
  }, [to, slug]);

  return Component;
};

export default RedirectPage;
